import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";

/* tslint:disable-next-line:no-any */
export var authFactory = function authFactory(authFn) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cb) {
      var _token;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return authFn();

            case 3:
              _token = _context.sent;
              cb(_token);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              cb('', _context.t0.message);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90YWcvYXV0aEZhY3RvcnkudHMiXSwibmFtZXMiOlsiYXV0aEZhY3RvcnkiLCJhdXRoRm4iLCJjYiIsInRva2VuIiwibWVzc2FnZSJdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7QUFLQSxPQUFPLElBQU1BLFdBQVcsR0FBRyxTQUFkQSxXQUFjLENBQUNDLE1BQUQ7QUFBQTtBQUFBLHdFQUFtQyxpQkFBT0MsRUFBUDtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLHFCQUV0Q0QsTUFBTSxFQUZnQzs7QUFBQTtBQUVwREUsY0FBQUEsTUFGb0Q7QUFHMURELGNBQUFBLEVBQUUsQ0FBQ0MsTUFBRCxDQUFGO0FBSDBEO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBSzFERCxjQUFBQSxFQUFFLENBQUMsRUFBRCxFQUFLLFlBQWVFLE9BQXBCLENBQUY7O0FBTDBEO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBQW5DOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsQ0FBcEIiLCJzb3VyY2VzQ29udGVudCI6WyIvKiB0c2xpbnQ6ZGlzYWJsZS1uZXh0LWxpbmU6bm8tYW55ICovXG5leHBvcnQgdHlwZSBFcnJvclJlYXNvbiA9IGFueTtcblxuZXhwb3J0IHR5cGUgQXV0aENhbGxiYWNrID0gKHRva2VuOiBzdHJpbmcsIGVycm9yUmVhc29uPzogRXJyb3JSZWFzb24pID0+IHZvaWQ7XG5cbmV4cG9ydCBjb25zdCBhdXRoRmFjdG9yeSA9IChhdXRoRm46ICgpID0+IFByb21pc2U8c3RyaW5nPikgPT4gYXN5bmMgKGNiOiBBdXRoQ2FsbGJhY2spID0+IHtcbiAgdHJ5IHtcbiAgICBjb25zdCB0b2tlbiA9IGF3YWl0IGF1dGhGbigpO1xuICAgIGNiKHRva2VuKTtcbiAgfSBjYXRjaCAoZXJyKSB7XG4gICAgY2IoJycsIChlcnIgYXMgRXJyb3IpLm1lc3NhZ2UpO1xuICB9XG59O1xuIl19